/* ============
 * Actions for the profile module
 * ============
 *
 * The actions that are available on the
 * profile module.
 */
import Vue from 'vue';
import UserProxy from '@/proxies/UserProxy';
import message from '@/constants/_message';
import types from './mutation-types';

export const view = ({ commit }, id) => {
  commit(types.FETCH_USER);
  new UserProxy().view(id)
    .then((response) => {
      commit(types.FETCH_USER_SUCCESS, response);
    }).catch((error) => {
      commit(types.FETCH_USER_FAIL, error);
    });
};

export const update = ({ commit }, data) => {
  commit(types.UPDATE_USER);
  new UserProxy().update(data)
    .then((response) => {
      commit(types.UPDATE_USER_SUCCESS, response);
      Vue.notify({
        group: 'notification',
        title: 'Success',
        text: message.PROFILE_UPDATED,
        type: 'success'
      });
    }).catch((error) => {
      commit(types.UPDATE_USER_FAIL, error);
      Vue.notify({
        group: 'notification',
        title: 'Error',
        text: message.PROFILE_NOT_UPDATED,
        type: 'error'
      });
    });
};

export default {
  view,
  update
};
